import {
  NEXT_PREV_PAGE_COUNT,
  MAX_PAGES,
} from "./pagination.constants";

export const getInactivePages = (
  activePageNumber,
  prev
) => {
  return Array.from(
    { length: NEXT_PREV_PAGE_COUNT },
    (_, i) => i + 1
  )
    .map(item =>
      prev
        ? activePageNumber - item
        : activePageNumber + item
    )
    .sort((a, b) => a - b);
};

export const getPagesArray = (
  activePageNumber,
  totalPages
) => {
  const pagesArray = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );
  if (pagesArray.length <= MAX_PAGES) {
    return pagesArray;
  }

  if (activePageNumber <= MAX_PAGES) {
    return [...pagesArray.slice(0, MAX_PAGES)];
  }

  if (activePageNumber > pagesArray?.length - MAX_PAGES) {
    return [
      ...pagesArray.slice(
        Math.max(pagesArray.length - MAX_PAGES, 0)
      ),
    ];
  }

  return [
    activePageNumber,
    ...getInactivePages(activePageNumber, false),
  ];
};
